<template>
  <div id="store-locator" class="">
    <div class="search">
      <div class="grid-x2">
        <div class="columns">

          <div class="column col-auto select-wrapper" v-if="listLocations">
            <label for="location">Posizione</label>
            <select id="location" v-model="selectLocation" @change="filterLocation($event)">
              <option value="">Seleziona la località</option>
              <option v-for="(value, key) in listLocations" :value="value.centro.toLowerCase()" :key="key">{{ value.centro
              }}</option>
            </select>
          </div>

          <div class="column col-auto select-wrapper" v-if="listDoctors">
            <label for="doctor">Medici</label>
            <select id="doctor" v-model="selectDoctor" @change="filterDoctor($event)">
              <option value="">Seleziona Medico</option>
              <option v-for="(value, key) in listDoctors" :value="key" :key="key">{{ value.name }}</option>
            </select>
          </div>

          <div class="column col-auto clear" v-if="showClear">
            <label>.</label>
              <button class="btn btn-link" @click="reset">
                <i class="icon icon-close"></i>
                <span>
                  <strong v-html="notFoundLabel"></strong>
                  <span class="hide-md" v-html="clearLabel"></span>
                </span>
              </button>
          </div>

        </div>
      </div>
    </div>


    <div class="map-view show-sm">
      <div :class="[{ active: isMappa }, 'map-view-mappa']" @click="viewMappa"><i
          class="icon icon-location"></i><span>MAPPA</span>
      </div>
      <div :class="[{ active: isLista }, 'map-view-lista']" @click="viewLista"><i
          class="icon icon-menu"></i><span>ELENCO</span>
      </div>
    </div>
    <div class="container  grid-x2">
      <div class="columns col-gapless map-wrapper" :class="[{ 'loading loading-lg': loading }, classMappa]">
        <div class="column col-4 col-xl-5 col-lg-5 col-md-6 lista">
          <simplebar id="lista-store" class="scroll" data-simplebar-auto-hide="false">
            <div v-for="(m, i) in resultsElement" :key="i" :ref="'window' + i" @click.prevent="toggleInfoWindow(m, i)"
               :class="{ active: currentMidx == i, scheda: 1 == 1 }">
              <!--<p class="livello">{{m.placeResult.livello}}</p>-->
              <h4>{{m.placeResult.name}}</h4>
              <p v-if="m.placeResult.type !== ''">{{m.placeResult.type}}</p>
              <p>{{m.placeResult.address}}</p>
              <h6 v-if="m.placeResult.phone !== ''">Tel. 800.81.69.69</h6>
              <div class="wbp_wrapper store-button">
                <div class="vc_btn3-container vc_btn3-inline"><a class="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3"  href="#" @click.stop @click.prevent="goTo(m.placeResult.url)" title="">Vai alla clinica</a></div>
                <div class="vc_btn3-container vc_btn3-inline"><a class="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3" href="#" @click.stop @click.prevent="showForm(m.placeResult.centro)">Prenota visita</a></div>
              </div>
            </div>
          </simplebar>
        </div>
        <div class="column col-8 col-xl-7 col-lg-7 col-md-6 col-sm-12 mappa">
          <gmap-map :center="center" :zoom="zoom" ref="map" style="width: 100%; height: 100%" :options="optionsMap">
            
            <gmap-marker :key="index" v-for="(m, index) in resultsElement" :position="m.position" :clickable="true"
              :draggable="false" @click="toggleInfoWindow(m, index)" :icon="pinPath" />
          </gmap-map>
        </div>
      </div>
    </div>
    <modal ref="form" v-if="showModal" @close="showModal = false" @update="updateModal">
        <div slot="body" v-html="formBody"></div>
        <div slot="message" v-html="formMessage"></div>
    </modal>
  </div>
</template>

<script>
import { gmapApi } from 'gmap-vue';
import modal from './components/modal.vue';
import axios from 'axios';
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import { mapStyle } from './mapstyle';


window.getItineraire = function (lat, lng, mylat, mylng) {
  var saddr = "";
  if (typeof mylat != "undefined" && typeof mylng != "undefined")
    saddr = "saddr=" + mylat + "," + mylng + "&";

  window.open("http://maps.google.com/maps?" + saddr + "daddr=" + lat + "," + lng, "_blank");
  return;
}


export default {
  name: 'App',
  computed: {
    google: gmapApi,
    clearLabel() {
      return "Visualizza tutti i " + this.markers.length + " negozi"
    },
    showClear() {
      return false;
    },
    pinPath() {
      return this.assetsPath + "mini-pin.png";
    },
    pinHoverPath() {
      return this.assetsPath + "hover-pin.png";
    },
    clusterPath() {
      return this.assetsPath + "Icon_store_";
    },
    radius() {
      return this.range * 1000
    },
    rangeLabel() {
      return this.range + ' km';
    },
    placeLabel() {
      if (this.place) {
        let address = '';

        if (this.place.address_components) {
          address = [
            (this.place.address_components[0] && this.place.address_components[0].short_name || ''),
            (this.place.address_components[1] && this.place.address_components[1].short_name || ''),
            (this.place.address_components[2] && this.place.address_components[2].short_name || '')
          ].join(' ');
        }

        return address
      } else {
        return '';
      }
    }

  },
  data() {
    return {
      showModal: false,
      formTitle: 'Prenota ora la tua visita',
      formBody: null,
      formMessage: "",
      isMappa: true,
      isLista: false,
      classMappa: 'view-mappa',
      resetC: false,
      center: { lat: 41.9027835, lng: 12.4963655 },
      stores: {},
      doctors: {},
      listLocations: [],
      listDoctors: [],
      originalLocations: [],
      originalDoctors: [],
      selectLocation: '',
      selectDoctor: '',
      notFoundLabel: '',
      zoom: 15,
      loading: false,
      markers: [],
      bounds: [],
      resultsElement: [],
      myPos: null,
      range: 25,
      place: null,
      latLng: {
        lat: 41.9027835,
        lng: 12.4963655
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        pixelOffset: {
          width: 0,
          height: -65
        }
      },
      optionsMap: {
        zoom: 7,
        minZoom: 5,
        maxZoom: 15,
        center: { lat: 41.9027835, lng: 12.4963655 },
        zoomControl: true,
        panControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        styles: mapStyle
      }
    }
  },
  components: {
    modal,
    simplebar
  },
  async created() {
    this.loading = true;
    await this.$gmapApiPromiseLazy();
    let stores = await this.getMarkers();
    this.stores = stores;
    let doctors = await this.getDoctors();
    this.doctors = doctors;
    this.log('loaded stores', stores.data);
    this.log('loaded doctors', doctors.data);
    this.setMarkersInit(stores.data);
    this.setLocations(stores.data);
    this.setDoctors(doctors.data);
  },
  methods: {
    updateModal({status, message}){
      console.log(status, message);
      if (status == 'mail_sent') {
        this.formBody = '<h4>'+message+'</h4>';
        setTimeout(() => {
          window.location.href = '/grazie-per-averci-contattato/';
        }, 1000);
      } else {
        this.formMessage = message;
      }
    },
    cleanUrl(url){
      return url.replace(/([^:]\/)\/+/g, "$1");
    },
    filterLocation(event) {
      this.selectLocation = event.target.value;
      if (this.selectLocation == '') {
        this.reset();
        return;
      }
      this.resultLocation([this.selectLocation]);
      this.filterDoctors(this.selectLocation);
      this.selectDoctor = '';
    },
    filterDoctors(location){
      let tmp = [];
     
      this.originalDoctors.forEach(function(v){
        const result = v.centri.filter(centro => centro.slug == location);
        if (result.length) {
          tmp.push(v);
        }
      });

      console.log(tmp);
      this.listDoctors = tmp;
    },
    filterDoctor(event) {
      this.selectDoctor = event.target.value;
      if (this.selectDoctor == '') {
        this.selectLocation = '';
        this.reset();
        return;
      }
      this.selectLocation = '';
      if (typeof this.listDoctors[this.selectDoctor]['centri'] !== 'undefined') {
        const locations = this.listDoctors[this.selectDoctor]['centri'].map(i => i.slug);
        this.resultLocation(locations);
      }
      // this.log('filterDoctor', this.selectLocation , this.selectDoctor);
    },
    setLocations(locs) {
      this.listLocations = locs;
      this.originalLocations = locs;
    },
    setDoctors(docs) {
      this.listDoctors = docs;
      this.originalDoctors = docs;
    },
    viewMappa() {
      this.isMappa = true;
      this.isLista = false;

      this.classMappa = this.isMappa ? 'view-mappa' : 'view-lista';
    },
    viewLista() {
      this.isMappa = false;
      this.isLista = true;

      this.classMappa = this.isMappa ? 'view-mappa' : 'view-lista';
    },
    center_changed() {
      this.log('cambio center da cluster')
    },
    getDoctors() {
      this.log('isdev', this.isDev);
      if (!this.isDev && typeof window.VSTOptions !== "undefined") {
        let url = window.VSTOptions.ajaxurl;
        let data = new FormData;
        data.append('action', window.VSTOptions.doctors);
        data.append('nonce', window.VSTOptions.nonce);
        return axios.post(url, data)
      }
      // caricamento json statico per test 
      return axios.get('doctors.json')
    },
    getMarkers() {
      this.log('isdev', this.isDev);
      if (!this.isDev && typeof window.VSTOptions !== "undefined") {
        let url = window.VSTOptions.ajaxurl;
        let data = new FormData;
        data.append('action', window.VSTOptions.action);
        data.append('nonce', window.VSTOptions.nonce);
        return axios.post(url, data)
      }
      // caricamento json statico per test 
      return axios.get('stores.json')
    },
    getForm(centro) {
      this.log('isdev', this.isDev);
      if (!this.isDev && typeof window.VSTOptions !== "undefined") {
        let url = window.VSTOptions.ajaxurl;
        let data = new FormData;
        data.append('action', window.VSTOptions.form);
        data.append('nonce', window.VSTOptions.nonce);        
        data.append('centro', centro);
        return axios.post(url, data)
      }
      return axios.get('form.json')
    },
    goTo(url){
      var cleanUrl = this.cleanUrl(url);
      window.open(cleanUrl);
    },
    showForm(centro) {
      
      this.loading = true;
      // console.log(centro);
      const form = this.getForm(centro);
      form.then((value) => {

        if(value.data.data.html){
          this.formBody = value.data.data.html;
          this.showModal = true;
          
        }
        this.loading = false;
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
        this.showModal = false;
      });
    },
    toggleInfoWindow (marker, idx) {
      this.center = marker.position;
      this.zoom = 10;
      this.infoWindowPos = marker.position;
      // this.infoOptions.content = this.renderStoreMap(marker)

      // let sidebar = document.querySelector('#lista-store .simplebar-content-wrapper');
      
      console.log(marker);
      console.log(this.$refs.map);


      // sidebar.scrollIntoView({ behavior: 'smooth' });
      const windzow = this.$refs["window"+idx];
      

      const container = document.querySelector('#lista-store .simplebar-content-wrapper');
      container.scrollTo({ top: windzow[0].offsetTop, behavior: 'smooth' });

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }

      //if different marker set infowindow to open and reset current marker index
      else {
        // this.infoWinOpen = true;
        this.currentMidx = idx;
        this.viewMappa();
      }
    },
    renderStoreMap(marker){
      let content = '';
      content += '<h6>' + marker.placeResult.name + '</h6>'
      return content;
    },
    reset() {
      this.log(this.resultsElement.length)
      this.log(this.markers.length)
      this.loading = true;
      this.clearResults();
    },
    clearResults() {
      this.place = null;
      this.zoom = 4;
      this.range = 50;
      this.myPos = null;
      this.center = this.latLng;
      this.infoWinOpen = false;
      this.resultsElement = this.markers;
      this.loading = false;
      this.listDoctors = this.originalDoctors;
      this.listLocations = this.originalLocations;
      this.$forceUpdate();
      this.fitBounds();
    },
    myPosition() {
      this.loading = true;
      let _this = this

      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          let pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          _this.center = pos
          _this.myPos = pos
          _this.resultFilter(pos);
          _this.loading = false;
        }, function () {
          _this.$refs.map.fitBounds(_this.bounds);
          _this.loading = false;
        });
      }
    },
    fitBounds() {
      this.bounds = new window.google.maps.LatLngBounds();

      let ns = 0;
      this.resultsElement.forEach(marker => {
        ns++;
        if (ns < 500)
          this.bounds.extend(marker.position);
      });

      if (!this.bounds.isEmpty()) {
        this.$refs.map.fitBounds(this.bounds);
        // this.$refs.cluster.$clusterObject.setMinimumClusterSize(4);
      } else {
        if (this.place && this.place.geometry)
          this.$refs.map.panTo(this.place.geometry.location);

        this.zoom = 7;
      }
    },
    setPlace(place = null) {
      if (!place)
        return;

      this.place = place

      this.$forceUpdate();

      if (!this.place.geometry) {
        // Se il valore non è nell'elenco dell'autocomplete -> ERROR
        window.alert("No details available for input: '" + this.place.name + "'");
        return;
      }

      // Se il place ha una geometry, lo mostro.
      if (this.place.geometry) {

        let center = this.place.geometry.location;
        this.center = {
          lat: center.lat(),
          lng: center.lng(),
        };
        this.resultFilter(this.center);
      }
    },
    resultLocation(location) {
      this.bounds = new window.google.maps.LatLngBounds();
      const locs = typeof location == "object" ? location : [location];

      let resultFilter = [];
      for (var i = 0; i < this.markers.length; i++) {
        // this.log(locs.indexOf(this.markers[i].placeResult.centro.toLowerCase()));
        if (locs.indexOf(this.markers[i].placeResult.centro.toLowerCase()) != -1) {
          // this.log(this.markers[i].placeResult.name,this.markers[i].distance)
          resultFilter.push(this.markers[i]);
          this.bounds.extend(this.markers[i].position);
        }
      }
      this.resultsElement = resultFilter.reverse();
      this.fitBounds();
    },
    resultFilter(pos) {
      this.bounds = new window.google.maps.LatLngBounds();
      this.resultsElement = [];

      let resultFilter = [];
      let center = new window.google.maps.LatLng(pos.lat, pos.lng);

      for (var i = 0; i < this.markers.length; i++) {
        let latLng = new window.google.maps.LatLng(this.markers[i].position.lat, this.markers[i].position.lng);

        this.markers[i].placeResult.distance = window.google.maps.geometry.spherical.computeDistanceBetween(center, latLng);
        this.markers[i].distance = parseInt(this.markers[i].placeResult.distance);

        if (this.markers[i].distance <= this.radius) {
          // this.log(this.markers[i].placeResult.name,this.markers[i].distance)
          resultFilter.push(this.markers[i]);
          this.bounds.extend(this.markers[i].position);
        }
      }

      if (!this.bounds.isEmpty()) {
        // riordino elenco per vicinanza dal center
        resultFilter.sort((a, b) => b.distance - a.distance);
        this.resultsElement = resultFilter.reverse();

        this.notFoundLabel = `${this.resultsElement.length} Negozi filtrati - `
        this.fitBounds();
      } else {
        this.notFoundLabel = "Nessun negozio filtrato - "
      }
    },
    setMarkersInit(stores) {
      this.markers = []
      for (var i = 0; i < stores.length; i++) {
        if (parseInt(stores[i].lat) === 0 || parseInt(stores[i].lng) === 0) { continue; }

        let marker = {}
        marker.position = {
          lat: parseFloat(stores[i].lat),
          lng: parseFloat(stores[i].lng)
        }
        marker.placeResult = stores[i];

        this.markers.push(marker);
      }
      this.resultsElement = this.markers;
      this.fitBounds();
      this.loading = false;
    }
  },
  watch: {
    range() {
      if (this.center)
        this.resultFilter(this.center);
      else if (this.place) {
        if (this.place.geometry) {
          let center = this.place.geometry.location;
          this.center = {
            lat: center.lat(),
            lng: center.lng(),
          };
          this.resultFilter(this.center);
        }
      }
    },
    zoom(value) {
      this.log('zoom: ', value);
    }
  }
}
</script>

<style lang="scss" >
$primary-color: #063328;
$secondary-color: #E6EEED;
$button-color: #3C7E7B;
$border-color: #A7D1CF;
$terziary-color: #C6FDCF;
$text-color: #333233;

$gray-color: #ABA49D;
$gray-color-light: #F3F5F6;
$size-2x: 1920px !default;

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700&display=swap');


//@import "node_modules/spectre.css/src/spectre";
@import "node_modules/spectre.css/src/variables";
@import "node_modules/spectre.css/src/mixins";

/*! Spectre.css v#{$version} | MIT License | github.com/picturepan2/spectre */
// Reset and dependencies
@import "node_modules/spectre.css/src/normalize";
@import "node_modules/spectre.css/src/base";

// Elements
@import "node_modules/spectre.css/src/typography";
@import "node_modules/spectre.css/src/buttons";
@import "node_modules/spectre.css/src/forms";
@import "node_modules/spectre.css/src/labels";

// Layout
@import "node_modules/spectre.css/src/layout";
@import "node_modules/spectre.css/src/badges";

@import "node_modules/spectre.css/src/animations";
@import "node_modules/spectre.css/src/utilities/loading";


@import "../icons.css-master/src/icons";

#store-locator {
  font-family: Montserrat, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: $text-color;

  h3.title {
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    font-weight: 400;
    margin-bottom: 20px;
    line-height: 53.44px;

    @media (max-width: $size-sm) {
      font-size: 22px;
      line-height: 33.44px;
      margin-left: 15px;
      margin-right: 15px;
    }

    @media (max-width: $size-xs) {
      font-size: 18px;
      line-height: 23.44px;
    }
  }

  .subtitle {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 27.94px;
    letter-spacing: 3.5%;
    margin-bottom: 40px;

    @media (max-width: $size-sm) {
      margin-left: 15px;
      margin-right: 15px;
    }
  }

  .search {
    padding: 30px 16px 30px 110px;
    text-align: left;

    @media (min-width: $size-sm) {
      // margin-bottom: 30px;
    }

    @media (max-width: 1350px) {
      padding: 30px 16px 30px 30px;
    }

    background-color: $primary-color;
    color: white;

    .columns{
      justify-content: center;
    }

    label {
      font-size: 14px;
      color: white;
      display: block;
      margin-bottom: 5px;
      font-weight: 400 !important;
    }

    .clear label{
      color: $primary-color;
    }

    select {
      padding-top: 7px;
      padding-bottom: 7px;
      border-radius: 20px;
      border: 0px;
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      cursor: pointer;
    }

    .select-wrapper {
      position: relative;
      margin-right: 16px;
      select{
        padding-left: 2em;
        padding-right: 4em;

        background-image: url(../public/arrow.svg);
        background-repeat: no-repeat, repeat;
        background-position: right .7em top 50%, 0 0;
        background-size: .65em auto, 100%;
      }
    }

    &>div {
      @media (max-width: $size-xs) {
        margin-bottom: 1em;
      }
    }
  }

  .map-view {
    position: relative;
    display: flex;
    width: 100%;
    border: 1px solid $gray-color;
    z-index: 1;

    div {
      cursor: pointer;
      display: inline-block;
      flex: 1 0 50%;
      width: 50%;
      padding: 10px;
      border-right: 1px solid $gray-color;

      &:hover,
      &.active {
        background-color: $secondary-color;
      }

      &:last-child {
        border: 0px;
      }

      text-align: center;

      span {
        display: inline-block;
        float: none;
        vertical-align: middle;
        margin-left: 10px;
        font-size: 14px;
        line-height: 18px;
        color: $primary-color;
        font-weight: 600;
      }
    }
  }

  h4 {
    font-family: Montserrat;
  }

  h6 {
    font-family: Montserrat;
  }

  p {
    font-family: Montserrat;
  }

  .labelresult {
    @media (min-width: $size-sm) {
      margin-bottom: 70px;
    }
  }

  .btn {
    // padding-right: 2em;
    // padding-left: 2em;
    border-color: $button-color !important;
    color: $button-color !important;

    font-size: 16px;
    line-height: 1em;
    // letter-spacing: 0.8px;
    border-radius: 20px;

    @media (max-width: $size-xs) {
      // width: 100%;
    }

    &-primary {
      background-color: $button-color !important;
      color: white !important;
    }

    &:hover {
      background-color: $button-color !important;
      color: white !important;
    }
  }

  .range {
    .badge {
      @media (min-width: $size-sm) {
        position: absolute;
        margin-right: 15px;
      }
    }

    .badge[data-prebadge]::before {
      box-shadow: none;
      background: none;
      color: rgba($primary-color, 0.6);
      font-size: 16px;
      letter-spacing: 0.035em;
      font-weight: 600;
      font-family: Montserrat, "Helvetica Neue", Arial, sans-serif;

      position: absolute;
      margin-top: -5px;
      left: 0;
      width: auto;
      text-align: left;
      border: 0px;
      height: 0.9rem;
      line-height: 1;
      min-width: 0.9rem;
      padding: 0.1rem 0.2rem;
      text-align: center;
      white-space: nowrap;
      content: attr(data-prebadge);
      text-transform: uppercase;
      display: inline-block;
      transform: none;

      @media (max-width: $size-sm) {
        display: none;
      }
    }

    .badge[data-badge]::after {
      transform: none;
      box-shadow: none;
      background: none;
      color: rgba($primary-color, 0.6);
      font-size: 16px;
      letter-spacing: 0.035em;
      font-weight: 600;
      font-family: Montserrat, "Helvetica Neue", Arial, sans-serif;
      position: absolute;
      margin-top: -5px;
      right: 0;
      width: auto;
      text-align: left;
      border: 0px;
    }

    input[type=range] {
      -webkit-appearance: none;
      margin: 18px 0;
      width: 100%;
    }

    input[type=range]:focus {
      outline: none;
    }

    input[type=range]::-webkit-slider-runnable-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      box-shadow: none;
      background: $gray-color;
      border-radius: 2px;
      border: 0;
    }

    input[type=range]::-webkit-slider-thumb {
      box-shadow: none;
      height: 13px;
      width: 13px;
      border: 0;
      border-radius: 50%;
      background: $gray-color;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -4px;
    }

    input[type=range]:focus::-webkit-slider-runnable-track {
      background: #367ebd;
    }

    input[type=range]::-moz-range-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      box-shadow: none;
      background: $gray-color;
      border-radius: 2px;
      border: 0;
    }

    input[type=range]::-moz-range-thumb {
      box-shadow: none;
      height: 13px;
      width: 13px;
      border: 0;
      border-radius: 50%;
      background: $gray-color;
      cursor: pointer;
    }

    input[type=range]::-ms-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      box-shadow: none;
      background: transparent;
      border-color: transparent;
      border-width: 0;
      color: transparent;
    }

    input[type=range]::-ms-fill-lower {
      background: $gray-color;
      border: 0;
      border-radius: 2px;
      box-shadow: none;
    }

    input[type=range]::-ms-fill-upper {
      background: $gray-color;
      border: 0;
      border-radius: 2px;
      box-shadow: none;
    }

    input[type=range]::-ms-thumb {
      box-shadow: none;
      height: 13px;
      width: 13px;
      border: 0;
      border-radius: 50%;
      background: $gray-color;
      cursor: pointer;
    }

    input[type=range]:focus::-ms-fill-lower {
      background: $gray-color;
    }

    input[type=range]:focus::-ms-fill-upper {
      background: $gray-color;
    }
  }

  .cluster>div {
    color: white !important;
    font-family: Montserrat, "Helvetica Neue", Arial, sans-serif !important;
    font-weight: 600;
    font-size: 16px !important;

  }
}

#store-locator .container {
  padding-left: 0;
  padding-right: 0;
  width: 100%;
}


.map-wrapper {
  position: relative;

  &.view-mappa{
    height: 40em;
  }

  @media (max-width: $size-sm) {
    &.view-mappa {
      .lista {
        display: none;
      }
    }

    &.view-lista {
      .lista {
        display: block;
      }
      .mappa {
        display: block;
      }
    }
  }
}

.lista {
  background-color: white;




  @media (max-width: $size-sm) {
    position: absolute;
    top: 90px;
    left: 10px;
    width: calc(100% - 20px);

    padding: 0;
    border: 1px solid #EDEDED;
    background-color: #FFFFFF;
    z-index: 6;
    padding: 15px !important;
    overflow: hidden;
  }
}

.mappa {
  min-height: 40em;
  height: 40em;
  @media (max-width: $size-sm) {
    position: absolute !important;
  }
}

.gm-style .gm-style-iw-c {
  padding: 30px !important;
}

.gm-style-iw-d {
  padding: 0px !important;
  margin: 0px !important;
}

.gm-style-iw-t {
  bottom: 36px !important;
}

.gm-style .gm-style-iw-c,
#lista-store .simplebar-content>* {
  border-radius: 2px;

  box-shadow: none;

  padding: 30px 16px 10px 16px;
  font-size: 16px;

  p.livello {
    margin: 0px;
    display: inline-block;
    border: 1px solid $border-color;
    background-color: $terziary-color;
    color: $primary-color;
    border-radius: 25px;
    padding: 2px 12px 2px 24px;
    font-size: 14px;
    line-height: 1em;
    font-weight: 400;
    background-image: url(../public/info.svg);
        background-repeat: no-repeat, repeat;
        background-position: left .7em top 50%, 0 0;
        background-size: .65em auto, 100%;
  }

  h4 {
    font-size: 24px;
    line-height: 29px;
    font-weight: 700;
    margin: 16px 0px;
    color: $primary-color;
  }

  h6 {
    color: $button-color;
    font-weight: 700;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 8px;
  }

  p {
    font-weight: 300;
    line-height: 24px;
    color: $text-color;
    margin: 0;
  }

  .btn_wrapper {
    margin-top: 20px;
    padding-bottom: 20px;
    display: flex;
    gap: 10px;
    border-bottom: 1px solid $gray-color-light;
  }

  .btn {
    font-family: Montserrat, "Helvetica Neue", Arial, sans-serif;
    font-weight: 700 !important;
    padding: 10px 20px !important;
    border-radius: 20px !important;
    background-color: transparent !important;

    &::after {
      display: none;
    }

    &-primary {
      background-color: $button-color !important;
      color: white !important;
    }

    &:hover {
      background-color: $button-color !important;
      color: white !important;
    }

  }

  .orari {
    padding: 15px 25px;
    background-color: rgba($primary-color, 0.05);
  }

  strong {
    font-weight: 700;
  }
}

#lista-store {
  list-style: none;

  @media (min-width: 960px) {
    // margin: 15px 5px 15px 25px;
  }


  .simplebar-content-wrapper {
    padding-right: 10px;
  }

  .simplebar-content>* {

    padding: 20px 15px 20px 110px;

    @media (max-width: 1350px) {
      padding: 20px 15px 20px 30px;
    }

    margin: 0;
    cursor: pointer;

    &:hover,
    &.active {
      background-color: rgba($primary-color, 0.05);
    }

    .percorso:hover {
      background-color: #FFF;
      border-radius: 2px;
    }

    &:last-child {
      border-bottom: 0px;
    }
  }
}

.scroll {
  height: 40em;

  @media (max-width: $size-sm) {
    height: 32em;
  }

  overflow-y: auto;
  scroll-snap-type: y mandatory;

  .simplebar-content>* {
    scroll-snap-align: start;
  }
}

.scheda h6{
  margin-top: 16px;
}

.text-center {
  text-align: center;
}

/*brian */
.store-button a {
  border-radius: 50px;
}

.store-button {
  display: flex;
  gap: 17px;
  margin-top: 1rem;
}


.store-button .vc_btn3-container a {
  color: #fff;
  background-color: #004237;
  background-image: none;
  font-size: 16px;
  font-weight: 700;
  border-radius: 50px;
}
.store-button .vc_btn3-container a:hover, 
.store-button .vc_btn3-container a:visited,
.store-button .vc_btn3-container a:focus {
  color: #fff;
}

#ltx-widgets-footer + .copyright-block{
  position: relative !important;
}
.gm-style-iw  .wbp_wrapper.store-button{ flex-direction:column; gap: unset; }

#store-locator{
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 600px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    position: relative;
  }

  @media (max-width: $size-sm) {
    .modal-container {
    width: auto;
    }
  }

  .modal-header h3 {
    margin-top: 0;
    color: $primary-color;
  }

  .modal-body {
    margin: 20px 0;
    padding: 0px !important;
    .cliniche-form{
      background-color: #fff;
      input:not([type="submit"]):not([type="button"]):not([type="radio"]):not([type="checkbox"]),
      select,
      textarea{
        border: 1px solid #CCD5E3;
      }
      input[type="submit"]{
        color: #FFF;
      }
      select{
        padding: 15px 18px;
        width: 100%;
        background-color: #FFF;
      }
    }
    h4{
      padding: 30px;
    }
  }

  .modal-default-button {

  }
  .modal-close{
    position: absolute;
    display: block;
    z-index: 99;
    right: 10px;
    top: 30px;
    background: none;
    border: 0;
    background-image: url(../public/close.svg);
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
}

.store-locator-wrapper{
  .wpb_content_element{
    margin-bottom: 0px !important;
  }
}

</style>